import React from 'react'
import { Sticky } from 'react-stickup-ay'

import styled, { css } from 'styled-components'
import { white } from 'styles/legacyShared/constants/colors'
import Filters from './components/Filters'

const WrapperClass = styled.div<{ isSticky: boolean }>`
  position: relative;
  z-index: 99;

  ${({ isSticky }) =>
    isSticky
      ? css`
          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
          left: 0 !important;
          right: 0;
          width: 100% !important;
        `
      : ''}
`

const Container = styled.div`
  background: ${white};
`

const Grid = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  min-height: 60px;
`

function OutfitNavigation({ isSticky }) {
  return (
    <WrapperClass isSticky={isSticky}>
      <Container className="container">
        <Grid>
          <Filters />
        </Grid>
      </Container>
    </WrapperClass>
  )
}

const StickyStylesProvider = styled.div`
  .stickyElement {
    &::before {
      content: '';
      display: block;
      height: 20px;
      margin-top: -20px;
      background-color: ${white};
    }
  }
`

const StyledSticky = styled(Sticky)`
  width: 100% !important;
  z-index: 50;
  margin-top: 15px;
  margin-bottom: 25px;
`

export function StickyOutfitNavigation({ container }) {
  return (
    <StickyStylesProvider>
      <StyledSticky
        container={container}
        stickyProps={{ className: 'stickyElement' }}
      >
        {({ isSticky }) => <OutfitNavigation isSticky={isSticky} />}
      </StyledSticky>
    </StickyStylesProvider>
  )
}
